<template>
	<div class="homepage">
		<common-header></common-header>
		<div class="text-left flex">
			<div class="left-menu">
				<ul class="side-nav">
					<li class="nav-item">
						<a>订单中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/order','state=1')">待付款</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=2')">待发货</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=3')">待评价</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=4')">退款售后</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>我的钱包</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage/couponList')">优惠券</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>我的关注</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage/collect')">商品收藏</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>账户设置</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage/userSetting')">个人资料</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/userManage/userSetting')">真实资料</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/userManage/addressList')">收货地址</el-link></li>
						</ul>
					</li>
					<!-- <li class="nav-item">
						<a>我的团购</a>
						<ul>
							<li class="nav-item"><el-link href="">待付款</el-link></li>
							<li class="nav-item"><el-link href="">待发货</el-link></li>
							<li class="nav-item"><el-link href="">待评价</el-link></li>
							<li class="nav-item"><el-link href="">退款售后</el-link></li>
						</ul>
					</li> -->
				</ul>
			</div>
			<div class="right-container">
				<div class="user-info flex">
					<div class="user-user text-center">
						<el-image class="header-pic" :src="getWebPic(this.userInfo.headerpic)"></el-image>
						<div class="user-name">
							<strong>{{ this.userInfo.nickname }}</strong>
						</div>
						<div v-if="userInfo.vip">
							<img class="vip-icon" src="../../assets/vip.png" />
							<span>{{ userInfo.vipName }}</span>
						</div>
						<div v-else>
							<img class="vip-icon" src="../../assets/novip.png" />
							<span>普通用户</span>
						</div>
					</div>
					<div class="wallet background-clip">
						<div><strong>我的钱包</strong></div>
						<div class="flex">
							<div class="flex-item">
								<div><el-link @click="toPage('/userManage/couponList')">{{ couponNum }}</el-link></div>
								<div>优惠券</div>
								<div><el-link @click="toPage('/userManage/couponCenter')">领券</el-link></div>
							</div>
							<div class="flex-item">
								<div><el-link @click="toPage('/userManage/collect')">{{ collectNum }}</el-link></div>
								<div>收藏</div>
							</div>
							<div class="flex-item">
								<div>{{ userInfo.jifen || '0' }}</div>
								<div>积分</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 订单部分 -->
				<div class="orders-container">
					<el-divider content-position="left">我的订单</el-divider>
					<div class="flex order-menu text-center">
						<div class="order-menu-item">
							<el-link @click="toPage('/order','state=0')">
								<i class="el-icon-s-order"></i>
								<div>全部订单</div>
							</el-link>
						</div>
						<div class="order-menu-item">
							<el-link @click="toPage('/order','state=1')">
								<i class="el-icon-warning"></i>
								<div>待付款</div>
							</el-link>
						</div>
						<div class="order-menu-item">
							<el-link @click="toPage('/order','state=2')">
								<i class="el-icon-truck"></i>
								<div>待发货</div>
							</el-link>
						</div>
						<div class="order-menu-item">
							<el-link @click="toPage('/order','state=3')">
								<i class="el-icon-chat-line-square"></i>
								<div>待评价</div>
							</el-link>
						</div>
						<div class="order-menu-item">
							<el-link @click="toPage('/order','state=4')">
								<i class="el-icon-question"></i>
								<div>退款/售后</div>
							</el-link>
						</div>
					</div>
				</div>
				<!-- 订单部分结束 -->
				<!-- 浏览历史 -->
				<div class="guess" v-if="historyList.length">
					<div class="flex flex-start text-left">
						<img src="../../assets/temp/h1.png" />
						<div style="padding: 20px;">
							<p class="tit">猜你喜欢</p>
							<p class="tit2">Guess You Like It</p>
						</div>
					</div>
					<div class="goods-item">
						<div class="section">
							<div class="section-item" v-for="(item, index) in historyList" :key="index" @click="toDetail(item.goods_id)">
								<div class="goods-pic"><img :src="getWebPic(item.smpic)" alt="" /></div>
								<p class="goods-title" :title="item.name">{{ item.name }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import commonHeader from '../../components/common/commonHeader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			coverTransform: 'translateY(0px)',
			coverTransition: '0s',
			moving: false,
			historyList: [],
			shareList: [],
			collectNum: 0,
			couponNum: 0,
			shareInfo: {
				provider: '',
				sence: '',
				type: 0, //分享为0图文1纯文字2纯图片3音乐4视频5小程序
				imageUrl: '',
				title: '',
				miniProgram: {
					path: '',
					type: 2, //0已发布2体验版
					webUrl: 'http://uniapp.dcloud.io'
				}
			},
			modalShow: false,
			couponList: [],
			companyName: this.companyName
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		this.getUserData();
	},
	methods: {
		getUserData() {
			if (!this.userInfo.id) {
				this.historyList = [];
				this.collectNum = 0;
				this.couponNum = 0;
				this.userInfo.jifen = 0;
				return false;
			}
			this.$request
				.post('/home.user/getUserData', {
					userid: this.userInfo.id ? this.userInfo.id : '',
					token: this.userInfo.token ? this.userInfo.token : ''
				})
				.then(res => {
					console.log(res.data);
					this.$emit('showLoading', false);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.historyList = res.data.historyList;
						this.collectNum = res.data.collectNum;
						this.couponNum = res.data.couponNum;
					}
				})
				.catch(err => {
					console.log(err);
					this.$emit('showLoading', false);
				});
		},
		
	}
};
</script>
<style lang="scss">
.el-container {
	.el-main {
		.homepage{
			background-color: #f0f3ef !important;
		}
		.left-menu {
			width: 170px;
			background-color: #fff;
			.side-nav {
				> .nav-item {
					padding: 15px 20px;
					border-bottom: 1px solid #f3f3f3;
					a {
						font-size: 15px;
						font-weight: bold;
						text-decoration: none;
						line-height: 40px;
					}
					.nav-item {
						a {
							font-size: 14px;
							line-height: 30px;
							&:hover {
								cursor: pointer;
							}
						}
					}
				}
			}
		}
		.right-container {
			flex: 1;
			padding: 20px 0 0 20px;
			background-clip: content-box;
			.user-info {
				background-color: #fff;
				background-color: transparent;
				.user-user {
					width: 200px;
					height: 200px;
					background-color: $base-color;
					padding-top: 20px;
					div {
						background-color: transparent;
						color: #fff;
					}
					.header-pic {
						width: 80px;
						height: 80px;
						border-radius: 50px;
						border: 3px solid #ebebeb;
					}
					.user-name {
						font-size: 16px;
						line-height: 40px;
					}
					.vip-icon {
						width: 20px;
						height: 20px;
						vertical-align: middle;
						margin-right: 7px;
					}
				}
				.wallet {
					flex: 1;
					padding: 10px 0;
					background-color: #fff;
					div {
						line-height: 35px;
						text-align: center;
					}
					.flex-item {
						flex: 1;
					}
				}
			}
			.orders-container {
				background-color: #fff;
				padding: 15px;
				margin-top: 15px;
				.order-menu-item {
					flex: 1;
				}
				.el-link {
					color: $base-color;
					line-height: 35px;
					i {
						font-size: 24px;
					}
					font-size: 15px;
				}
			}
			.guess {
				background-color: #fff;
				margin-top: 15px;
				.section {
					width: 100%;
					margin: 0;
				}
			}
		}
	}
}
</style>
